import {adjunto, seguimiento} from './state';

/**
 * Establecer listasChequeo
 */
export function establecerListasChequeo(state, listas_chequeo) {
  state.listas_chequeo = listas_chequeo;
}

/**
 * Establecer empresas
 */
export function establecerEmpresas(state, empresas) {
  state.empresas = empresas;
}

/**
 * Establecer empresas_filtro
 */
export function establecerEmpresasFiltro(state, empresas) {
  state.empresas_filtro = empresas;
}

/**
 * Establecer id empresa filtro
 */
export function establecerIdEmpresaFiltro(state, id_empresa) {
  state.filtro.id_empresa = id_empresa;
}

/**
 * Establecer hallazgos
 */
export function establecerHallazgos(state, hallazgos) {
  state.hallazgos = hallazgos;
}


/**
 * Establecer filtro_hallazgos
 */
export function establecerFiltroHallazgos(state, {id_lista, id_empresa}) {
  state.filtro_hallazgos.id_lista = id_lista;
  state.filtro_hallazgos.id_empresa = id_empresa;
}

/**
 * Establecer accion
 */
export function establecerAccion(state, accion) {
  state.accion = accion;
}

/**
 * Establecer modal_seguimiento
 */
export function mostrarModalSeguimiento(state) {
  state.modal_seguimiento.mostrar = true;
}

/**
 * Restablecer seguimiento
 */
export function restablecerSeguimiento(state) {
  state.seguimiento = seguimiento();
}

/**
 * Establecer id_empresa
 */
export function establecerIdEmpresaSeguimiento(state, id_empresa) {
  state.seguimiento.id_empresa = id_empresa;
}

/**
 * Establecer id_hallazgo
 */
export function establecerIdHallazgoSeguimiento(state, id_hallazgo) {
  state.seguimiento.id_hallazgo = id_hallazgo;
}


/**
 * Establecer seguimiento
 */
export function establecerSeguimiento(state, seguimiento) {
  state.seguimiento = seguimiento;
}

/**
 * Restablecer adjunto
 */
export function restablecerAdjunto(state) {
  state.adjunto = adjunto();
}
